import { createApp } from "vue";
import GiftCardOrderApp from "./GiftCardOrderApp.vue";
import { clearDataset, extractAppData } from "../../utils";
import { useRecaptcha } from "../../components/recaptcha";
export async function initGiftCardOrderApp() {
    const el = document.getElementById('giftCardOrderApp');
    if (!el) {
        return;
    }
    clearDataset(el);
    const data = extractAppData(el);
    const recaptcha = await useRecaptcha();
    createApp(GiftCardOrderApp, {
        ...data,
        recaptcha,
        minDate: new Date(data.minDate),
        maxDate: new Date(data.maxDate),
    }).mount(el);
}
